import "./HomePlataformaSection.scss";
import FS_HOME_SERVICIOS_MANEJO_IMAGEN from "../../../assets/img/FS-HOME-SERVICIOS-MANEJO-IMAGEN.png";
import FS_HOME_SERVICIOS_SEGUIMIENTO_IMAGEN from "../../../assets/img/FS-HOME-SERVICIOS-SEGUIMIENTO-IMAGEN.png";
import FS_HOME_SERVICIOS_DESARROLLO_IMAGEN from "../../../assets/img/FS-HOME-SERVICIOS-DESARROLLO-IMAGEN.png";
import FS_LAPTOP_HOME from "../../../assets/img/FS-LAPTOP-HOME.png";
import g_evolution_logo_text from "../../../assets/img/g_evolution_logo_text.png";
import RegularCard from "../../Molecules/RegularCard/RegularCard";
import content from "../../Pages/Home/content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";



function HomePlataformaSection() {
	const {language} = useLanguageCtx();

	const serivesInf = [
		{
			img: FS_HOME_SERVICIOS_MANEJO_IMAGEN,
			title: content[language].serviciosFirstCardTitle,
			content: content[language].serviciosFirstCardContent,
			linkText: content[language].serviciosFirstCardLink,
			linkHref: "/industry/manejo-de-flotas",
		},
		{
			img: FS_HOME_SERVICIOS_SEGUIMIENTO_IMAGEN,
			title: content[language].serviciosSecondCardTitle,
			content: content[language].serviciosSecondCardContent,
			linkText: content[language].serviciosSecondCardLink,
			linkHref: "/industry/fuerza-laboral",
		},
		{
			img: FS_HOME_SERVICIOS_DESARROLLO_IMAGEN,
			title: content[language].serviciosThirdCardTitle,
			content: content[language].serviciosThirdCardContent,
			linkText: content[language].serviciosThirdCardLink,
			linkHref: "/solutions/aplicaciones-moviles",
		},
	];

	return (
		<div className="homeServicesSection-container grid fullColumn top-space-section home">
			<div className="homeServicesSection-laptop-container">
				<img
					src={FS_LAPTOP_HOME}
					alt="Laptop"
					className="all-width-height aspect-ratio contain homeServicesSection-laptop-img"
				/>
			</div>
			<div className="homeServicesSection-banner-container all-columns">
				{/* <img
					src={FS_HOME_BANNER_MEDIO}
					alt="Banner-Servicios"
					className="all-width-height"
				/> */}
			</div>
			<div className="homeServicesSection-cards-container flex space-between center-cross-axis">
				{serivesInf.map((inf) => (
					<RegularCard
						key={inf.title}
						img={inf.img}
						title={inf.title}
						content={inf.content}
						section="home-services-section"
						linkText={inf.linkText}
						linkHref={inf.linkHref}
					/>
				))}
			</div>
			<div className="homeServicesSection-text-container">
				<img
					src={g_evolution_logo_text}
					alt="G EVOLUTION"
					className="homeServicesSection-logo aspect-ratio contain"
				/>
				<p className="t5 c-yellow yellow-line right-side no-space mt-20">
					{content[language].serviciosYellowTitle}
				</p>
				<p className="t2 c-white no-space mt-10">
					{content[language].serviciosBoldText}
				</p>
			</div>
			<div className="homeServicesSection-blue-bg all-columns"></div>
		</div>
	);
}

export default HomePlataformaSection;
